import React from 'react';
import { Row, Col} from 'react-bootstrap';
import './Ofrecemos.css';

const Ofrecemos = () => {
  // Asumiendo que tienes un array de imágenes con objetos que incluyen la ruta src
  const imagenes = [
    { src: '/images/ofrecemos1.png' },
    { src: '/images/ofrecemos2.png' },
    { src: '/images/ofrecemos3.png' },
    { src: '/images/ofrecemos4.png' },
    { src: '/images/ofrecemos5.png' },
    { src: '/images/ofrecemos6.png' },
  ];

  return (
    <div className="ofrecemos-container">
      <h2 className="ofrecemos-heading">Ofrecemos</h2>
      <Row className='g-0 ofrecemos-row'>
        {imagenes.slice(0, 3).map((imagen, index) => (
          <Col key={index} xs={12} sm={6} md={4} className="ofrecemos-col">
            <img src={imagen.src} alt={`Imagen ${index + 1}`} className="ofrecemos-image img-fluid" />
          </Col>
        ))}
      </Row>
      <Row className='g-0 ofrecemos-row'>
        {imagenes.slice(3, 6).map((imagen, index) => (
          <Col key={index} xs={12} sm={6} md={4} className="ofrecemos-col">
            <img src={imagen.src} alt={`Imagen ${index + 4}`} className="ofrecemos-image img-fluid"/>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default Ofrecemos;
